export const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
